@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

.trends .tabs {
  margin-block-end: 0;
  padding-block-end: 0;
}
.trends .tabs > div {
  justify-content: flex-end;
}
.trends .tabs [role='tablist'] {
  display: flex;
  gap: var(--cxy-spacing-xxsm);
  width: 100%;
}
.trends .tabs [role='tablist'] [role='tab'] {
  all: unset;
  padding: var(--cxy-spacing-xxsm) var(--cxy-spacing-sm);
  border-start-start-radius: var(--cxy-border-radius-m);
  border-start-end-radius: var(--cxy-border-radius-m);
  width: 100%;
}
.trends .tabs [role='tablist'] [role='tab'],
.trends .tabs [role='tablist'] [role='tab'] * {
  cursor: pointer;
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
  line-height: var(--cxy-lineHeight-m);
}
.trends .tabs [role='tablist'] [role='tab'] p {
  /* Also zeroes the margin cxy Progress sets under its value. */
  margin-block-end: 0;
}
.trends .tabs [role='tablist'] [role='tab'][aria-selected='true'] {
  background-color: var(--cxy-color-surface-primary-default-subtle);
  color: var(--cxy-color-text-default-body);
  border-bottom: none;
}
.trends .tabs [role='tablist'] [role='tab'][aria-selected='false']:hover {
  background-color: color-mix(in srgb, var(--cxy-color-container-raised), transparent 80%);
  color: var(--cxy-color-text-default-body);
}
.trends .tabs [role='tablist'] [role='tab'][disabled]:hover,
.trends .tabs [role='tablist'] [role='tab'][disabled] *:hover {
  cursor: not-allowed;
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
}
.trends .tabs [role='tablist'] [role='tab'][disabled][aria-selected='true'] {
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
}
.trends .tabs [role='tablist'] [role='tab'][disabled] p {
  color: var(--cxy-color-surface-primary-default-subtle-hover);
}
.trends .tabContent {
  @include cxy.stack(var(--cxy-spacing-xxxsm));
}
.trends .tabContent [data-testid='hit-rate'] {
  display: none;
}
.trends .tabContent[data-state='inactive'] {
  height: 0;
}
.trends tr td:not(:first-of-type) {
  padding-block: var(--cxy-spacing-xxxsm) var(--cxy-spacing-xxsm);
}
@container tableComponent (min-width: 800px) {
  .trends .tabContent [data-testid='hit-rate'] {
    display: block;
  }
  .trends tr td:not(:first-of-type) {
    padding-block: unset;
  }
}
.trends .footer {
  @include cxy.stack(var(--cxy-spacing-xsm));
  padding-block-end: 0;
}
.trends .footer:has(.footerRow[data-disabled='true']) {
  cursor: not-allowed;
}
.trends .footer [data-disabled='true'] {
  display: block;
}
.trends .footer [data-disabled='true'],
.trends .footer [data-disabled='true'] * {
  pointer-events: none;
  color: var(--cxy-color-surface-primary-default-subtle-hover);
}
.trends .footer [data-disabled='true'] img {
  opacity: 0.7;
}
.trends .footer .footerCell {
  padding-block: 0;
}
.trends .footer .footerCell > div {
  display: block;
}
.trends .hidden {
  padding: 0;
}
.trends .trendContainer {
  padding-block-end: var(--cxy-spacing-xsm);
}
.trends .hitRate {
  @include cxy.stack(var(--cxy-spacing-xxsm));
}
@container tableComponent (min-width: 800px) {
  .trends .hitRate {
    display: grid;
    grid-template-columns: 5fr 7fr;
    column-gap: 70px;
  }
  .trends .hidden {
    padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
  }
}
.trends .statsTrigger {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: var(--cxy-spacing-xxxsm);
  margin-block: var(--cxy-spacing-xsm);
}
.trends .stats div {
  width: 100%;
}
.trends .stats .barChartWrapper {
  padding-bottom: var(--cxy-spacing-xxsm);
}

.statsTable,
.barChartWrapper {
  margin: var(--cxy-spacing-xsm) var(--cxy-spacing-xxsm);
}
@container tableComponent (min-width: 800px) {
  .statsTable,
  .barChartWrapper {
    margin-inline: var(--cxy-spacing-sm);
  }
}

.barChartWrapper {
  margin-block-start: 0;
}

.topTrendsCard {
  @include cxy.stack(var(--cxy-spacing-xxsm));
  padding: var(--cxy-spacing-xsm);
  color: var(--cxy-color-text-default-body);
  min-width: 0;
  overflow: hidden;
  height: 100%;
}
.topTrendsCard .topSection {
  display: grid;
  grid-template-columns: 55px 1fr 55px;
}
.topTrendsCard .topSection .betInfo {
  font-weight: var(--cxy-fontWeight-semiBold);
  min-width: 0;
  overflow: hidden;
}
.topTrendsCard .topSection .betInfo .betTitle {
  font-weight: var(--cxy-fontWeight-bold);
  color: var(--cxy-color-text-default-body);
  font-size: var(--cxy-fontSize-m);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.topTrendsCard .topSection .betIcon {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.topTrendsCard .aiInfo {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  .topTrendsCard .aiInfo {
    flex-direction: column;
    gap: var(--cxy-spacing-xxsm);
    align-items: flex-start;
  }
}
.topTrendsCard .topTrendsBarChart {
  margin-top: auto;
}
.topTrendsCard .hitRate {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxxsm);
  font-size: 11px !important;
  margin-left: auto;
}
.topTrendsCard .hitRate span {
  font-size: 11px !important;
}
.topTrendsCard .hitRate .targetIcon {
  width: 16px;
  height: 16px;
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .statsIcon {
    filter: invert(1);
  }
  .targetIcon {
    filter: invert(1);
  }
  .topTrendsCard {
    border: 1px solid var(--cxy-color-interactive-primary);
  }
  .trends .tabs [role='tablist'] [role='tab'] {
    &[aria-selected='true'] [role='progressbar'] {
      background-color: var(--cxy-color-container-strong);
    }

    &[aria-selected='false']:hover {
      background-color: transparent;
    }
  }
}
